import { SortDirection } from "@js2/components/@types";
import { MENU_ITEMS } from "@js2/components/gridconfig/consts";

export const INIT_YARA_DASHBOARD_FILTER_VALUES = {
  name: "",
  owner: "My Rulesets",
  status: "all",
  source: undefined
};

export const INIT_YARA_DASHBOARD_FILTER_MENU_DATA = {
  name: INIT_YARA_DASHBOARD_FILTER_VALUES.name,
  owner: {
    label: INIT_YARA_DASHBOARD_FILTER_VALUES.owner,
    value: INIT_YARA_DASHBOARD_FILTER_VALUES.owner
  },
  status: { label: "Status", value: INIT_YARA_DASHBOARD_FILTER_VALUES.status },
  source: { label: "Source", value: INIT_YARA_DASHBOARD_FILTER_VALUES.source }
};

export const DEFAULT_YARA_URL_PARAMS = `?owner=${encodeURIComponent(
  INIT_YARA_DASHBOARD_FILTER_VALUES.owner
).replace(/%20/g, "+")}`;

export const DEFAULT_SORT = {
  field: "favorite",
  direction: "desc" as SortDirection
};

export const MENU_ITEMS_OVERRIDE = [
  MENU_ITEMS.EXACT_DATE,
  MENU_ITEMS.SHOW_LATEST_MATCH_TIME,
  MENU_ITEMS.SHOW_NEW_MATCHES,
  MENU_ITEMS.SHOW_LAST_UPDATED,
  MENU_ITEMS.SHOW_SOURCE
];
